import React from "react"
import { WeightingReport } from "types/engineOutput.types"
import {
  weightingRows,
  weightingSummary,
  weightingTitle,
} from "./weightingReportRows"

interface WeightingReportViewProps {
  report: WeightingReport
}

/**
 * What one CALCWEIGHTS achieved: per question, each group's target against
 * the weighted share it reached, with the weight range and efficiency above.
 */
const WeightingReportView: React.FC<WeightingReportViewProps> = ({ report }) => (
  <div className="flex flex-col gap-3 p-2">
    <div>
      <p className="m-0 font-semibold">{weightingTitle(report)}</p>
      <p className="m-0">{weightingSummary(report)}</p>
      {!report.met && (
        <p className="m-0 text-red-600">
          The targets were not all met, so the weights were put back.
        </p>
      )}
    </div>
    {report.notes.length > 0 && (
      <ul className="m-0 pl-5">
        {report.notes.map((n) => (
          <li key={n}>{n}</li>
        ))}
      </ul>
    )}
    {report.questions.map((q) => (
      <table key={q.label} className="text-sm border-collapse">
        <thead>
          <tr className="text-left">
            <th className="pr-4">{q.label}</th>
            <th className="pr-4 text-right">Respondents</th>
            <th className="pr-4 text-right">Target %</th>
            <th className="pr-4 text-right">Achieved %</th>
            <th className="text-right">Difference</th>
          </tr>
        </thead>
        <tbody>
          {weightingRows(q).map((r) => (
            <tr key={r.key} className={r.off ? "text-red-600" : undefined}>
              <td className="pr-4">{r.group}</td>
              <td className="pr-4 text-right">{r.respondents}</td>
              <td className="pr-4 text-right">{r.target}</td>
              <td className="pr-4 text-right">{r.achieved}</td>
              <td className="text-right">{r.difference}</td>
            </tr>
          ))}
        </tbody>
      </table>
    ))}
  </div>
)

export default WeightingReportView
